import { Link, useNavigate } from "react-router-dom";
import { useSectionNav } from "@/lib/useSectionNav";
import Newsletter from "./Newsletter";

const EXPLORE = [
  { label: "Our Philosophy", target: "philosophy" },
  { label: "Why Gaia Space", target: "about" },
];
const CONNECT = [
  { label: "Newsletter", target: "newsletter" },
  { label: "Contact", target: "contact" },
];

const Footer = () => {
  const goToSection = useSectionNav();
  const navigate = useNavigate();

  const replayIntro = () => {
    navigate("/", { state: { scrollTo: "hero" } });
    setTimeout(() => window.dispatchEvent(new Event("gaia:replay-intro")), 60);
  };

  return (
    <footer className="bg-gaia-charcoal pb-10 pt-20 text-gaia-bg md:pt-24" data-testid="site-footer">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Newsletter />

        <div className="mt-16 flex flex-col justify-between gap-14 border-b border-gaia-bg/15 pb-16 md:flex-row md:items-end">
          <button onClick={() => navigate("/", { state: { scrollTo: "hero" } })} className="text-left">
            <img src="/gaia-logo.png" alt="Gaia Space" className="h-24 w-auto md:h-28" style={{ filter: "brightness(0) invert(1)", opacity: 0.95 }} />
            <p className="mt-6 max-w-xs font-sans text-sm font-light leading-relaxed text-gaia-bg/60">
              A sanctuary for movement, breath, nature and conscious living.
            </p>
          </button>

          <div className="grid grid-cols-2 gap-12 md:gap-20">
            <div>
              <span className="font-sans text-[11px] uppercase tracking-[0.24em] text-gaia-taupe">Explore</span>
              <ul className="mt-5 space-y-3 font-sans text-sm font-light">
                {EXPLORE.map((l) => (
                  <li key={l.target}>
                    <button onClick={() => goToSection(l.target)} className="text-gaia-bg/80 transition-colors hover:text-gaia-terracotta" data-testid={`footer-link-${l.target}`}>
                      {l.label}
                    </button>
                  </li>
                ))}
                <li>
                  <Link to="/gatherings" className="text-gaia-bg/80 transition-colors hover:text-gaia-terracotta" data-testid="footer-link-gatherings">
                    Gatherings
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <span className="font-sans text-[11px] uppercase tracking-[0.24em] text-gaia-taupe">Connect</span>
              <ul className="mt-5 space-y-3 font-sans text-sm font-light">
                {CONNECT.map((l) => (
                  <li key={l.target}>
                    <button onClick={() => goToSection(l.target)} className="text-gaia-bg/80 transition-colors hover:text-gaia-terracotta" data-testid={`footer-link-${l.target}`}>
                      {l.label}
                    </button>
                  </li>
                ))}
                <li><a href="mailto:hello@gaiaspace.life" className="text-gaia-bg/80 transition-colors hover:text-gaia-terracotta" data-testid="footer-email">hello@gaiaspace.life</a></li>
                <li><a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-gaia-bg/80 transition-colors hover:text-gaia-terracotta" data-testid="footer-instagram">Instagram</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col gap-3 font-sans text-xs font-light tracking-wide text-gaia-bg/50 md:flex-row md:items-center md:justify-between">
          <span>© {new Date().getFullYear()} Gaia Space.</span>
          <button
            onClick={replayIntro}
            className="uppercase tracking-[0.28em] text-gaia-bg/45 transition-colors duration-500 hover:text-gaia-terracotta"
            data-testid="footer-replay-intro"
          >
            Replay Intro
          </button>
          <span className="tracking-[0.2em]">Created with intention in Southern Spain.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
